import React from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';
import { GridRenderEditCellParams, useGridApiContext } from '@mui/x-data-grid-pro';
import { useTranslation } from 'react-i18next';

type Props = {
  gridRenderParams: GridRenderEditCellParams;
  labelKey: string;
  id: string;
};

const GridCellEditCheckbox = (props: Props) => {
  const { labelKey, id, gridRenderParams } = props;
  const { id: cellId, value, field } = gridRenderParams;
  const { t } = useTranslation();
  const apiRef = useGridApiContext();

  const changeField = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.checked;
    apiRef.current.setEditCellValue({ id: cellId, field, value: newValue });
  };
  return (
    <FormControlLabel
      sx={{ marginLeft: 0, '.MuiFormControlLabel-label': { fontSize: '0.875rem' } }}
      control={<Checkbox id={id} checked={value} onChange={changeField} />}
      label={t(labelKey)}
    />
  );
};

export default GridCellEditCheckbox;
